import { useEffect } from 'react';
const useKey = (callback, eventTypes = ['keydown'], node = document) => {
    useEffect(() => {
        for (const eventType of eventTypes) {
            node.addEventListener(eventType, callback);
        }
        return () => {
            for (const eventType of eventTypes) {
                node.removeEventListener(eventType, callback);
            }
        };
    }, [callback]);
};
export default useKey;
